import {
  useRampFlagFullFidelityRunsPerChart,
  useRampFlagIncreaseFullScreenMaxRuns,
} from '../../util/rampFeatureFlags/linePlotFeatureFlags';
import {DEFAULT_LINE_PLOT_MAX_NUM_BUCKETED_RUNS} from '../WorkspaceDrawer/Settings/runLinePlots/maxRunDefaults';

/**
 * current rules for allowing the perforamnce warning banner
 * 1. a user must be enrolled in either the max runs beta or the full screen max runs beta
 * 2. this only applies to full fidelity panels
 *  - this can apply in either the panel or the workspace
 *  - a worksapce in full fidelity mode might show the banner even if all panels are in sampling mode
 * 3. the configured limit has to be higher than the allowed default limit.
 */
export const useMaxRunsWarningBanner = ({
  isFullFidelity,
  numRuns,
}: {
  isFullFidelity: boolean;
  numRuns: number;
}) => {
  const isInFullScreenMaxRunsBeta = useRampFlagIncreaseFullScreenMaxRuns();
  const isInFullFidelityRunsPerChartBeta =
    useRampFlagFullFidelityRunsPerChart();
  const isHigherLimit = numRuns > DEFAULT_LINE_PLOT_MAX_NUM_BUCKETED_RUNS;

  return (
    isFullFidelity &&
    (isInFullScreenMaxRunsBeta || isInFullFidelityRunsPerChartBeta) &&
    isHigherLimit
  );
};
